import { defineComponent } from 'vue'

interface Props {
  tData?: string
  class?: unknown
  contentClass?: string
  disabled?: boolean
  onClick?: (payload: Event) => void
}

export default defineComponent<Props>((props, context) => {
  return () => (
    <td
      t-data={props.tData}
      class={['min-h-14 bg-inherit p-4 align-top', props.class]}
      onClick={(e) => props.disabled !== true && props.onClick?.(e)}
    >
      <div class={['w-full break-words', props.contentClass]}>
        {context.slots.default?.()}
      </div>
    </td>
  )
}, {
  name: 'VTableBodyCell',
  props: ['tData', 'class', 'contentClass', 'disabled', 'onClick']
})
